import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/submit_arrow.svg'


const _hoisted_1 = { class: "s_subscribe" }
const _hoisted_2 = { class: "sub-middle" }
const _hoisted_3 = {
  key: 0,
  style: {"color":"yellow","font-size":"0.9rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-wrap" }, [
        _createElementVNode("h3", null, [
          _createTextVNode("Subscribe to"),
          _createElementVNode("br"),
          _createTextVNode("my newsletter")
        ]),
        _createElementVNode("span", null, "이메일을 입력해주시면 이력서와 포트폴리오를 보내드립니다.")
      ], -1)),
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          type: "text",
          placeholder: "Your email address"
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("button", { type: "submit" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "검색"
          })
        ], -1))
      ], 32),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}